export default __webpack_public_path__ + "static/media/glycan-img.d208daff.svg";